import { render, staticRenderFns } from "./CollectionTaskComment.vue?vue&type=template&id=017b5f3e&scoped=true&"
import script from "./CollectionTaskComment.vue?vue&type=script&lang=js&"
export * from "./CollectionTaskComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017b5f3e",
  null
  
)

export default component.exports